import type {VectorTile} from 'ol';
import type {Extent} from 'ol/extent';
import {type FeatureLike} from 'ol/Feature.js';
import type {Projection} from 'ol/proj';

import TileState from 'ol/TileState.js';

export function nocookieVectorTileLoadFunction(
  tile: VectorTile<FeatureLike>,
  url: string,
) {
  function noCookieLoaderFunction(
    extent: Extent,
    resolution: number,
    projection: Projection,
  ) {
    tile.setState(TileState.LOADING);
    fetch(url, {
      credentials: 'omit',
    })
      .then((response: Response) => {
        if (response.status === 204) {
          tile.setState(TileState.EMPTY);
          return undefined;
        }
        return response.arrayBuffer().then((data) => {
          const format = tile.getFormat();
          const features: any[] = format.readFeatures(data, {
            extent: extent,
            featureProjection: projection,
          });
          tile.setFeatures(features);
        });
      })
      .catch(() => {
        tile.setState(TileState.ERROR);
      });
  }
  tile.setLoader(noCookieLoaderFunction);
}
